import { Redirect } from "react-router-dom";

export const SESSION_TTL = 2 * 60 * 60 * 1000;

export const DoLogout = () => {
  window.localStorage.clear();
  return <Redirect to="/" />;
};

export const HelpLinks = () => {
  return (
    <>
      <br />
      <h6>Ayuda</h6>
      <p>
        <a href="https://docs.google.com/document/d/1ivm1OMstFjxKiLuuXmTxnFzZC7rnGzh74fZFQ14Tq64">
          Instructivo
        </a>
        <br />
        <a href="https://docs.google.com/document/d/1HpIAm4IoCrkTHshqzAFk750EqtXiGlghrZs14va6chU">
          Preguntas frecuentes
        </a>
      </p>
    </>
  );
};

export const GetDojoName = (dojos, dojoId) => {
  const result = dojos.find(({ id }) => id == dojoId);
  return result?.attributes?.name;
};

export const GetGradeName = (grades, gradeId) => {
  const result = grades.find(({ id }) => id == gradeId);
  return result?.attributes?.name;
};

export function buildDisplayName(i) {
  return i.name + " " + i.lastname + " (" + i.docNumber + ")";
}

export const provinces = {
  Ciudad_de_Buenos_Aires: "Ciudad de Buenos Aires",
  Buenos_Aires: "Buenos Aires",
  Catamarca: "Catamarca",
  Chaco: "Chaco",
  Chubut: "Chubut",
  Cordoba: "Córdoba",
  Corrientes: "Corrientes",
  Entre_Rios: "Entre Rios",
  Exterior: "Exterior",
  Formosa: "Formosa",
  Jujuy: "Jujuy",
  La_Pampa: "La Pampa",
  La_Rioja: "La Rioja",
  Mendoza: "Mendoza",
  Misiones: "Misiones",
  Neuquen: "Neuquen",
  Rio_Negro: "Rio Negro",
  Salta: "Salta",
  San_Luis: "San Luis",
  San_Juan: "San Juan",
  Santa_Cruz: "Santa Cruz",
  Santa_Fe: "Santa Fe",
  Santiago_del_Estero: "Santiago del Estero",
  Tierra_del_Fuego: "Tierra del Fuego",
  Tucuman: "Tucuman",
};

export const conceptos = [
  { id: "month-dojo.month-dojo", value: "Cuota Mensual" },
  { id: "day-dojo.day-dojo", value: "Día de pactica" },
  { id: "grade.grade", value: "Derecho de Exámen" },
];

export const times = [
  { id: "07:00:00.000", value: "07:00" },
  { id: "07:30:00.000", value: "07:30" },
  { id: "08:00:00.000", value: "08:00" },
  { id: "08:30:00.000", value: "08:30" },
  { id: "09:00:00.000", value: "09:00" },
  { id: "09:30:00.000", value: "09:30" },
  { id: "10:00:00.000", value: "10:00" },
  { id: "10:30:00.000", value: "10:30" },
  { id: "11:00:00.000", value: "11:00" },
  { id: "11:30:00.000", value: "11:30" },
  { id: "12:00:00.000", value: "12:00" },
  { id: "12:30:00.000", value: "12:30" },
  { id: "13:00:00.000", value: "13:00" },
  { id: "13:30:00.000", value: "13:30" },
  { id: "14:00:00.000", value: "14:30" },
  { id: "14:30:00.000", value: "14:30" },
  { id: "15:00:00.000", value: "15:00" },
  { id: "15:30:00.000", value: "15:30" },
  { id: "16:00:00.000", value: "16:00" },
  { id: "16:30:00.000", value: "16:30" },
  { id: "17:00:00.000", value: "17:00" },
  { id: "17:30:00.000", value: "17:30" },
  { id: "18:00:00.000", value: "18:00" },
  { id: "18:30:00.000", value: "18:30" },
  { id: "19:00:00.000", value: "19:00" },
  { id: "19:30:00.000", value: "19:30" },
  { id: "20:00:00.000", value: "20:00" },
  { id: "20:30:00.000", value: "20:30" },
  { id: "21:00:00.000", value: "21:00" },
  { id: "21:30:00.000", value: "21:30" },
];
